import baseApi from "../utils/ApiUtils";

export const questionnairesApi = (method, payload = null, params = null, id = null) => {
  const url = id ? `/masters/questionnaires/${id}/` : "/masters/questionnaires/";
  return baseApi(url, method, params, payload).then((response) => response.data);
};

export const questionnaireAnswersApi = (method, payload = null, params = null, id = null) => {
  const url = id ? `/masters/questionnaire_answers/${id}/` : "/masters/questionnaire_answers/";
  return baseApi(url, method, params, payload).then((response) => response.data);
};

export const feedbackSubmitApi = (payload) => {
  return baseApi("/feedback/submit/", "post", null, payload).then((response) => response.data);
};

export const feedbackResponsesApi = (method = "get", params = null) => {
  return baseApi("/feedback/responses/", method, params, null).then((response) => response.data);
};
